import firebase from "firebase/compat/app"
import 'firebase/compat/storage'

const firebaseConfig = {
  apiKey: "AIzaSyCDUoAhac6IfbkgGbO53326ailDsjg2CQE",
  authDomain: "storage-controlservice-b5ceb.firebaseapp.com",
  projectId: "storage-controlservice-b5ceb",
  storageBucket: "storage-controlservice-b5ceb.appspot.com",
  messagingSenderId: "1051763104300",
  appId: "1:1051763104300:web:a07b01d1380ba698dc8f89",
  measurementId: "G-KBDCSBKT9D"
};

  
  // Initialize Firebase
  const app = firebase.initializeApp(firebaseConfig);


export default app